function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18 0C8.059 0 0 8.059 0 18s8.059 18 18 18 18-8.059 18-18A18 18 0 0018 0zm.74 17a4.59 4.59 0 011 9.07v1.51a1 1 0 01-2 0v-1.47a4.6 4.6 0 01-3.59-4.48 1 1 0 012 0A2.59 2.59 0 1018.78 19a4.59 4.59 0 01-1-9.07V8.46a1 1 0 012 0V10a4.6 4.6 0 013.59 4.48 1 1 0 01-2 0A2.59 2.59 0 1018.78 17h-.04z",
  fillRule: "nonzero",
  fill: "#7F63FF"
});

function SvgDollarIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 36 36"
  }, props), _ref);
}

export default __webpack_public_path__ + "b32bbb2c56453edb42ebe8d6fae7dd3a.svg";
export { SvgDollarIc as ReactComponent };